Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers'

class Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessAuthorParser
  parse: (authorJson) ->
    builder = new Monitoring.Models.SocialContents.GoogleMyBusiness.Builders.GoogleMyBusinessAuthorBuilder()
    builder.setName(authorJson.name)
    builder.setProfilePhotoUrl(authorJson.avatar)
    builder.build()
